import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";
import Overlay from "Shared/Overlay";
import Button from "Shared/Button";
import Icon from "Shared/Icon";
import { RootContext } from "SiteLayout/Root";
import Transition from "Shared/Transition";
import * as styles from "./base.scss";
export var ModalType;
(function (ModalType) {
    ModalType[ModalType["None"] = 0] = "None";
    ModalType[ModalType["Success"] = 1] = "Success";
    ModalType[ModalType["Warning"] = 2] = "Warning";
    ModalType[ModalType["Danger"] = 3] = "Danger";
})(ModalType || (ModalType = {}));
class Modal extends React.PureComponent {
    componentDidMount() {
        this.forceUpdate();
    }
    renderTitleIfProvided() {
        return this.props.title ? (React.createElement("h2", { className: classnames(styles.title, {
                [styles.reserveSpaceForCloseButton]: this.props.reserveSpaceForCloseButton,
            }) }, this.props.title)) : null;
    }
    getModalIconFromType(type = this.props.type) {
        const wrapElement = (el) => (React.createElement("div", { className: styles.iconWrapper }, el));
        if (type === ModalType.Danger) {
            return wrapElement(React.createElement(Icon, { name: "remove-circle" }));
        }
        else if (type === ModalType.Warning) {
            return wrapElement(React.createElement(Icon, { name: "exclamation" }));
        }
        else if (type === ModalType.Success) {
            return wrapElement(React.createElement(Icon, { name: "check" }));
        }
        return null;
    }
    renderComponent() {
        const { onClose, isOpen, className, childContainerClassname, reserveSpaceForCloseButton, children, fadeDesign, isPersistent: isPresistent, disableTransition, } = this.props;
        const innerContent = (active) => {
            return (React.createElement("div", { className: classnames(styles.base, className, {
                    [styles.active]: active,
                    [styles.fadeModal]: !!fadeDesign,
                }) },
                React.createElement("div", { className: styles.innerContainer },
                    this.renderTitleIfProvided(),
                    this.getModalIconFromType(),
                    React.createElement("div", { className: classnames(childContainerClassname, {
                            [styles.reserveSpaceForCloseButton]: !this.props.title && reserveSpaceForCloseButton,
                        }) }, children),
                    React.createElement(Button, { className: styles.close, appearance: "clear", onClick: onClose },
                        React.createElement(Icon, { name: "close" })))));
        };
        return (React.createElement(Overlay, { enabled: isOpen, onClose: onClose, isPersistent: isPresistent }, !!disableTransition ? (innerContent(isOpen)) :
            (React.createElement(Transition, { in: isOpen, timeout: 200, appear: false }, (active) => (innerContent(active))))));
    }
    render() {
        return this.context.rootElementRef
            ? ReactDOM.createPortal(this.renderComponent(), this.context.rootElementRef)
            : null;
    }
}
Modal.contextType = RootContext;
export default Modal;
